{
  "tabs": {
    "chat": "Чат",
    "reminders": "Напоминания",
    "calendar": "Календарь",
    "settings": "Настройки"
  },
  "common": {
    "cancel": "Отмена",
    "save": "Сохранить",
    "confirm": "Подтвердить",
    "delete": "Удалить",
    "back": "Назад",
    "close": "Закрыть",
    "edit": "Редактировать",
    "search": "Поиск",
    "all": "Все",
    "loading": "Загрузка...",
    "error": "Что-то пошло не так",
    "notFound": "Не найдено",
    "tryAgain": "Пожалуйста, попробуйте снова",
    "retry": "Повторить",
    "undo": "Отменить",
    "pullToRefresh": "Потяните для обновления",
    "justNow": "только что"
  },
  "auth": {
    "welcome": "Добро пожаловать в FishMemory",
    "tagline": "Ваш помощник напоминаний WhatsApp теперь в вашем кармане.",
    "subtitle": "Ваш помощник напоминаний WhatsApp теперь в вашем кармане.",
    "phoneLabel": "Ваш номер WhatsApp",
    "phoneHint": "Мы отправим код подтверждения через WhatsApp",
    "invalidPhone": "Введите корректный номер телефона",
    "continue": "Продолжить",
    "enterPhone": "Введите номер WhatsApp",
    "phonePlaceholder": "Номер телефона",
    "sendCode": "Отправить код",
    "verifyTitle": "Подтвердите номер",
    "otpSentTo": "6-значный код отправлен на {{phone}} через WhatsApp",
    "enterFullCode": "Введите все 6 цифр",
    "invalidOtp": "Неверный код. Попробуйте снова.",
    "otpFailed": "Не удалось отправить код. Попробуйте снова.",
    "otpResent": "Код отправлен повторно",
    "resendIn": "Повторно через {{seconds}}с",
    "resendCode": "Отправить код повторно",
    "enterOtp": "Введите код из WhatsApp",
    "verify": "Подтвердить",
    "resend": "Отправить код повторно",
    "wrongNumber": "Неверный номер?",
    "backToPhone": "Назад к номеру",
    "editPhone": "Изменить номер",
    "error": "Ошибка",
    "setupTitle": "Настроим всё",
    "setupSubtitle": "Вы всегда можете изменить это в настройках",
    "namePlaceholder": "Ваше имя",
    "letsGo": "Завершить настройку",
    "skipForNow": "Пропустить"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Напишите сообщение...",
    "inputPlaceholder": "Напишите сообщение...",
    "typing": "FishMemory печатает...",
    "online": "В сети",
    "connecting": "Подключение...",
    "reconnecting": "Переподключение...",
    "offline": "Офлайн",
    "empty": "Начните разговор",
    "emptyHint": "Создавайте напоминания, проверяйте расписание или просите помощь.",
    "emptyAction": "Отправить пример напоминания",
    "actions": "Действия чата",
    "keep": "Сохранять сообщения",
    "clearTitle": "Очистить чат",
    "clearConfirm": "Удалить все сообщения с этого устройства? Это нельзя отменить.",
    "clear": "Очистить чат",
    "optionSelected": "Выбрано: {{label}}",
    "sendingSelection": "Отправка...",
    "connectionLost": "Переподключение..."
  },
  "reminders": {
    "title": "Мои напоминания",
    "active": "Активные",
    "today": "Сегодня",
    "thisWeek": "На этой неделе",
    "history": "История",
    "items": "элементы",
    "emptyTitle": "Пока нет напоминаний",
    "emptySubtitle": "Создайте напоминание в чате, и оно появится здесь.",
    "emptyAction": "Открыть чат",
    "filterActive": "Активные",
    "filterToday": "Сегодня",
    "filterWeek": "На неделе",
    "filterHistory": "История",
    "emptyState": "Пока нет напоминаний. Начните чат!",
    "swipeDone": "Готово",
    "swipeSnooze": "Отложить",
    "swipeDelete": "Удалить",
    "search": "Поиск напоминаний...",
    "upcoming": "Предстоящие",
    "completed": "Выполненные",
    "overdue": "Просроченные",
    "tomorrow": "Завтра",
    "synced": "Синхронизировано {{value}}",
    "swipeHint": "Смахните напоминание для действий",
    "noResults": "Напоминания не найдены",
    "noResultsHint": "Попробуйте другое слово или очистите поиск",
    "deleteAllFailed": "Не удалось удалить все напоминания"
  },
  "calendar": {
    "title": "Календарь",
    "today": "Сегодня",
    "tomorrow": "Завтра",
    "completed": "выполнено",
    "noEvents": "Нет событий",
    "noEventsSubtitle": "Выберите дату, чтобы увидеть напоминания и события.",
    "googleEvent": "Google Календарь",
    "legendActive": "Активные",
    "legendRecurring": "Повторяющиеся",
    "legendDone": "Выполнено",
    "legendGoogle": "Google",
    "previousMonth": "Прошлый месяц",
    "nextMonth": "Следующий месяц",
    "previousYear": "Прошлый год",
    "nextYear": "Следующий год",
    "goToToday": "Перейти к сегодня",
    "all": "Все",
    "active": "Активные",
    "done": "Выполнено",
    "paused": "Приостановлено"
  },
  "settings": {
    "title": "Настройки",
    "profile": "Профиль",
    "name": "Отображаемое имя",
    "enterName": "Введите имя",
    "language": "Язык",
    "uiLanguage": "Язык приложения",
    "uiLanguageHelp": "Меняет язык интерфейса, метки календаря и направление на этом устройстве.",
    "serverLanguage": "Язык чата",
    "serverLanguageHelp": "Меняет язык ответов сервера и сообщений напоминаний для вашей учетной записи.",
    "timezone": "Часовой пояс",
    "currentTimezone": "Текущий часовой пояс",
    "timezoneHelp": "Все времена напоминаний показываются в этом часовом поясе.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Сохранить часовой пояс",
    "timezoneSaved": "Часовой пояс обновлен",
    "detect": "Определить",
    "detectFailed": "Не удалось определить часовой пояс",
    "autoDetect": "Автоопределение по GPS",
    "notifications": "Уведомления",
    "notificationsHelp": "Повторные напоминания контролируют повторные оповещения после срабатывания напоминания. Разрешения на уведомления управляются в настройках телефона.",
    "pushEnabled": "Push-уведомления",
    "autoDoneOnFire": "Автоотметка при срабатывании",
    "autoDoneOnFireDesc": "Если выключено, напоминания остаются активными, пока вы их не отметите.",
    "googleCalendar": "Google Календарь",
    "google": "Google Календарь",
    "googleConnected": "Подключено",
    "googleDisconnected": "Не подключено",
    "googleConnectedHelp": "Новые напоминания могут автоматически синхронизироваться с календарём.",
    "googleDisconnectedHelp": "Подключите Google Календарь, чтобы синхронизировать напоминания и события.",
    "googleConnectFailed": "Не удалось подключить Google Календарь",
    "connected": "Подключено",
    "disconnected": "Не подключено",
    "connect": "Подключить",
    "disconnect": "Отключить",
    "autoSync": "Автосинхронизация новых напоминаний",
    "autosync": "Автосинхронизация новых напоминаний",
    "subscription": "Подписка",
    "trialUsed": "Пробный период: {{used}}/{{total}} использовано",
    "trialStatus": "Доступен пробный период",
    "activeStatus": "Активная подписка",
    "expiredStatus": "Подписка истекла",
    "unsubscribedStatus": "Нет подписки",
    "about": "О приложении",
    "version": "Версия",
    "logout": "Выйти",
    "logoutTitle": "Выход",
    "logoutConfirm": "Вы уверены, что хотите выйти?",
    "noName": "Имя не задано",
    "serverConnection": "Подключение к серверу",
    "serverUrl": "URL сервера",
    "serverEdit": "Изменить",
    "saveReconnect": "Сохранить и переподключиться",
    "resetDefault": "Сбросить по умолчанию",
    "invalidServerUrlTitle": "Неверный URL сервера",
    "invalidServerUrlMessage": "Введите корректный URL сервера http или https, например https://example.com",
    "uiLanguageChangeFailed": "Не удалось изменить язык приложения. Попробуйте снова.",
    "serverLanguageChangeFailed": "Не удалось изменить язык чата. Попробуйте снова.",
    "timezoneChangeFailed": "Не удалось изменить часовой пояс. Попробуйте снова.",
    "autoSyncChangeFailed": "Не удалось обновить автосинхронизацию. Попробуйте снова.",
    "nameChangeFailed": "Не удалось обновить отображаемое имя. Попробуйте снова.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Детали напоминания",
    "editTime": "Изменить время",
    "rename": "Переименовать",
    "snooze": "Отложить",
    "snooze15": "Отложить на 15 минут",
    "pause": "Пауза",
    "pauseReminder": "Поставить напоминание на паузу",
    "resume": "Возобновить",
    "resumeReminder": "Возобновить напоминание",
    "skip": "Пропустить следующее",
    "skipOccurrence": "Пропустить это срабатывание",
    "syncGoogle": "Синхронизировать с Google",
    "delete": "Удалить",
    "deleteTitle": "Удалить напоминание",
    "deleteConfirm": "Это напоминание будет удалено навсегда.",
    "deleteRecurringTitle": "Удалить повторяющееся напоминание",
    "deleteRecurringMessage": "Хотите пропустить это срабатывание или удалить всю серию?",
    "deleteThisOccurrence": "Пропустить это срабатывание",
    "deleteEntireSeries": "Удалить всю серию",
    "done": "Выполнено",
    "markDone": "Отметить как выполненное",
    "undo": "Восстановить",
    "undoPrompt": "Нужно снова активировать? Восстановите сейчас.",
    "recurring": "Повторяющееся",
    "nextRun": "Следующий запуск",
    "oneTime": "Одноразовое",
    "pending": "Ожидает",
    "sent": "Отправлено",
    "paused": "Приостановлено",
    "active": "Активно",
    "snoozed": "Отложено",
    "localTime": "Показано в вашем местном времени",
    "recurrence": "Повтор",
    "created": "Создано",
    "tags": "Теги",
    "fireCount": "Количество срабатываний",
    "actions": "Действия",
    "none": "Нет",
    "snoozeFailed": "Не удалось отложить напоминание",
    "pauseFailed": "Не удалось поставить напоминание на паузу",
    "resumeFailed": "Не удалось возобновить напоминание",
    "skipFailed": "Не удалось пропустить напоминание",
    "doneFailed": "Не удалось отметить напоминание как выполненное",
    "undoFailed": "Не удалось восстановить статус напоминания",
    "deleteFailed": "Не удалось удалить напоминание",
    "rescheduleTitle": "Перенести?",
    "rescheduleMsg": "Это напоминание просрочено. Хотите перенести его?",
    "reschedule15": "Через 15 минут",
    "reschedule60": "Через 1 час",
    "keepOverdue": "Оставить как есть"
  },
  "onboarding": {
    "slide1Title": "Добро пожаловать в FishMemory",
    "slide1Sub": "Ваш личный помощник напоминаний — работает через WhatsApp и всегда с вами.",
    "slide2Title": "Просто общайтесь естественно",
    "slide2Sub": "Пишите напоминания, как думаете: «Напомни позвонить маме завтра в 15:00» — мы сделаем остальное.",
    "slide3Title": "Ничего не пропустите",
    "slide3Sub": "Получайте своевременные уведомления, организуйте с тегами и контролируйте важное.",
    "getStarted": "Начать",
    "next": "Далее",
    "firstReminderTitle": "Создайте первое напоминание!",
    "firstReminderHint": "Попробуйте написать что-то вроде:",
    "firstReminderExample": "Напомни выпить воды завтра в 9 утра",
    "gotIt": "Понял!",
    "notifRationaleTitle": "Будьте вовремя",
    "notifRationaleBody": "FishMemory нужны уведомления, чтобы напоминать вам вовремя. Вы будете получать оповещения только о созданных вами напоминаниях.",
    "notifRationaleAllow": "Включить уведомления",
    "notifRationaleLater": "Позже",
    "swipeHint": "Смахните вправо для быстрых действий →",
    "calendarDragHint": "Перетащите для расширения ↕"
  }
}
